import type { SectionConfig } from '../lib/types';

export const adminUserSection: SectionConfig = {
  id: 'admin.adm', entity: 'adminUser', title: 'Admin Users',
  softDelete: false,
  defaultSort: { column: 'username', direction: 'asc' },
  columns: [
    { key: 'username', title: 'Username', sortable: true },
    { key: 'name', title: 'Name', sortable: true },
    { key: 'email', title: 'Email', sortable: true },
    { key: 'lock', title: 'Locked', type: 'boolean' },
    { key: 'lastLogin', title: 'Last Login', type: 'date' },
  ],
  formFields: [
    { key: 'username', title: 'Username', type: 'text', required: true },
    { key: 'password', title: 'Password', type: 'password' },
    { key: 'name', title: 'Name', type: 'text' },
    { key: 'email', title: 'Email', type: 'text' },
    { key: 'lock', title: 'Lock (prevent login)', type: 'boolean' },
    { key: 'allowedSections', title: 'Allowed Sections (comma-separated)', type: 'text' },
    { key: 'constraints', title: 'Constraints', type: 'text' },
  ],
};
